import request from '@/utils/request'

const prizeTypeURL = {
  List: '/platform-prize-category/list',
  Created: '/platform-prize-category/create',
  Update: '/platform-prize-category/update',
  Delete: '/platform-prize-category/delete'
}

// 获奖列表 & 详情(参数传id = *)
export function fetchPrizeTypeList (params) {
  return request({
    url: prizeTypeURL.List,
    method: 'get',
    params
  })
}

// 新增
export function createdPrizeType (data) {
  return request({
    url: prizeTypeURL.Created,
    method: 'post',
    data
  })
}

// 修改
export function updatePrizeType (data) {
  return request({
    url: prizeTypeURL.Update,
    method: 'post',
    data
  })
}

// 删除
export function deletePrizeType (data) {
  return request({
    url: prizeTypeURL.Delete,
    method: 'post',
    data
  })
}

export default {
  fetchPrizeTypeList,
  createdPrizeType,
  updatePrizeType,
  deletePrizeType
}
